import installationInstructions from './installationInstructions';

const garageCategoryContent = {
  installationInstructions
}

export { garageCategoryContent };
